export default "__VITE_ASSET__93yycJAZ__"